import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  abrirCheckout: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isSub: BehaviorSubject<boolean> = new BehaviorSubject(false);
  
  constructor(private httpService: HttpService) { 

  }

  makeSubscription(order: object | any) : Promise<any> {
    return this.httpService.post('subscriptions', order);
  }

  getListSubscription(id_store: string | any) : Promise<any> {
    let params : HttpParams = new HttpParams()
    .append('id_store', String(id_store));
    return this.httpService.get('subscriptions/list', params);
  }
 
  setIsSub(value: boolean) {
    this.isSub.next(value);
  }

  getIsSub(): Observable<any> {
    return this.isSub;
  }

  setAbrirCheckout(value: boolean) {
    this.abrirCheckout.next(value);
  }

  getAbrirCheckout(): Observable<any> {
    return this.abrirCheckout;
  }

  makeOrder(order: object | any) : Promise<any> {
    return this.httpService.post('orders', order);
  }

  makeOrderWholesale(order: object) : Promise<any> {
    return this.httpService.post('wholesales/orders', order);
  }

  addCustomer(id_store: string, customer: object) : Promise<any> {
    return this.httpService.post(`orders/${id_store}/addCustomer`, customer);
  }

  getFeeTransaction(id_store: string) : Promise<any> {
    return this.httpService.post(`orders/${id_store}/task`,{id_store});
  }


  getCost(id_store: string, data: object) : Promise<any> {
    // MOCK USPS - eliminar cuando el endpoint real esté disponible
    // const mock = [
    //   { CLASSID: '1', MailService: 'Priority Mail®', Rate: 9.25 },
    //   { CLASSID: '2', MailService: 'USPS Ground Advantage™', Rate: 7.50 }
    // ];
    // return Promise.resolve({ state: 'success', data: mock });
    // ---- llamada real ----
    return this.httpService.post(`orders/cost`, data);
  }

  getCostList( data: object) : Promise<any> {
    return this.httpService.post(`orders/costList`, data);
  }

  getCustomer(id_store: string, customer: any) : Promise<any> {
    return this.httpService.post(`orders/${id_store}/getCustomer`, customer);
  }

  getInfoCEP(cep: string ) : Promise<any> {
    let params : HttpParams = new HttpParams()
    .append('cep', String(cep));
    return this.httpService.get(`home/verify`,params);
  }

  getSeller(id:string,id_store:string){
   return this.httpService.get(`home/getSeller/${id_store}/${id}`);
  }

  getmethodspayment(){
    return this.httpService.get(`payments/list`)
  }

  getProvidersList(data:any) : Promise<any>{
    return this.httpService.post(`orders/providersList`,data)
  }


  getListPersonalized(id_store): Promise<any>{
    let params : HttpParams = new HttpParams()
    .append('id_store', String(id_store));
    return this.httpService.get('deliveries/listpersonalized', params)
  }




    validateCoupon(code: string, storeId: string, email: string, orderAmount: number): Promise<any> {
      

        //{
        //     "code": "ABC123",
        //     "store_id": "rednumbers",
        //     "email": "cliente@ejemplo.com", 
        //     "order_amount": 100.00
        // }
        // const discount = 10
        //   const info = {
        //     "state": "success",
        //     "coupon": {
        //         "id": 1,
        //         "code": "ABC123",
        //         "discount_type": "percentage",
        //         "discount_value": discount,
        //         "discount_amount": (orderAmount * discount) / 100,
        //         "max_uses": 100,
        //         "used_count": 1,
        //         "expires_at": "2024-12-31",
        //         "minimum_amount": 8
        //     },
        //     "summary": {
        //         "subtotal":  orderAmount,
        //         "discount_amount": (orderAmount * discount) / 100,
        //         "final_amount": orderAmount - ((orderAmount * discount) / 100)
        //     }
        // }
        // return new Promise((resolve, reject) => {
        //   resolve(info)
        //   reject('Error al usar el cupón')
        // })
        const data = {
          code,
          store_id: storeId,
          email,
          order_amount: orderAmount
        };
      return this.httpService.postCupon(`coupons/validate`, data)
    }





    useCoupon(code: string, storeId: string, email: string, orderId: string, orderAmount: number): Promise<any> {
        const data = {
          code,
          store_id: storeId,
          email,
          order_amount: orderAmount
        };

        //{
        //     "code": "ABC123",
        //     "store_id": "rednumbers",
        //     "email": "cliente@ejemplo.com", 
        //     "order_amount": 100.00
        // }

      
        return this.httpService.post(`admin/coupons/use`, data)
      }





}
